<template>
  <div>
    <app-header />

    <!-- Global loading - only show on initial auth check -->
    <div v-if="isInitialAuthLoading" class="app-loader">
      Loading...
    </div>

    <!-- Main content -->
    <router-view v-else />
    

  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import AppHeader from "@/components/AppHeader.vue";


@Component({
  components: { 
    AppHeader,
 
  }
})
export default class App extends Vue {
  private authInitialized = false;
  private appReady = false;

  get isAuthLoading() {
    return this.$store.getters["authentication/isAuthLoading"];
  }

  get isAuthenticated() {
    return this.$store.getters["authentication/isAuthenticated"];
  }

  get isInitialAuthLoading() {
    // Only show loading on the very first auth check
    return this.isAuthLoading && !this.authInitialized;
  }

  get isAppReady() {
    // App is ready when auth is initialized and either user is authenticated or on public route
    return this.authInitialized && (this.isAuthenticated || this.isPublicRoute) && this.appReady;
  }

  get isPublicRoute() {
    // Add your public routes here (like login page)
    const publicRoutes = ['/login', '/register', '/'];
    return publicRoutes.includes(this.$route.path);
  }

  async created() {
    try {
      await this.$store.dispatch("authentication/init");
    } catch (error) {
      console.error("Authentication initialization failed:", error);
    } finally {
      this.authInitialized = true;
      // Add a small delay to ensure everything is rendered properly
      this.$nextTick(() => {
        setTimeout(() => {
          this.appReady = true;
        }, 100);
      });
    }
  }
}
</script>

<style lang="scss">
html {
  // margin-left: calc(100vw - 100%);
  margin-right: 0;
}

input[type="text"]::placeholder {
  color: #6c757d8f;
}

.mb-10 {
  margin-bottom: 10rem;
}

.text-right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.dropdown-menu {
  position: absolute !important;
}

@media (min-width: 1400px) {
  .container-xxl,
  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1100px !important;
  }

  .container-user {
    max-width: 100% !important;
    padding: 0 !important;

    .navbar-dark .navbar-nav .nav-link {
      color: #ffffff !important;
    }
  }
}

.group-title {
  background: #f2f5f8;
  padding: 10px 15px;

//  font-family: "Inter";
  font-family: 'Albert Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  color: #111111;
}

.tab-link-title {
  //font-family: "Inter";
  font-family: 'Albert Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;

  color: #282828;
  border: none !important;

  &.active {
    border-bottom: 2px solid #00d393 !important;
  }
}

.login-box {
  .custom-control-label:before {
    top: 0.5rem !important;
  }

  .custom-control-label:after {
    top: 0.5rem !important;
  }
}

.treatment-dropdown {
  &.btn-group {
    .dropdown-toggle {
      display: flex;
      padding-top: 0;
      padding-bottom: 0;
      justify-content: space-between;
      align-items: center;
      color: #111111;
      font-size: 14px;
    }
  }
}

.treatment-dropdown-form {
  font-size: 14px;

  ul {
    padding: 0;
  }

  .custom-checkbox {
    margin-bottom: 4px !important;
  }

  .custom-control-label {
    &::before,
    &::after {
      top: 0.15rem;
    }
  }
}



// .btn-save {
//     background: linear-gradient(135deg, #2f45a5, #667bf2);
//     color: white;
//     font-weight: 600;

//     border-radius: 8px;
//     border: none;
//     box-shadow: 0 4px 15px rgba(47, 69, 165, 0.2);
//     transition: all 0.3s ease;
//     cursor: pointer;
//     font-size: 1rem;
//     line-height: 1.5;
// }

.bg-app-gray {
//  background-color: #f8fafc;
}

.app-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: 'Albert Sans', sans-serif;
  font-size: 18px;
  color: #282828;
}
/*
html {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}*/
</style>